import {
  ROUTE_PAGE_DASHBOARD_ACTIVITY,
  ROUTE_PAGE_DASHBOARD_MEMBERS,
  ROUTE_PAGE_DASHBOARD_SETTINGS,
  ROUTE_PAGE_DASHBOARD_TEMPLATES,
} from '@components/Router/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { matchPath, useLocation } from 'react-router-dom'

// The dashboard pages that are not a folder: templates, activity, members
// and team settings. Their routes carry no :folderId segment, so useParams
// reports the same empty id the Dashboard folder itself has (the API builds
// it with id: ''). Params alone therefore cannot tell /dashboard/:workspaceId
// from these pages — only the route can, and without it the Dashboard row
// stays lit while one of them is open.
const SECTION_ROUTES = [
  ROUTE_PAGE_DASHBOARD_TEMPLATES,
  ROUTE_PAGE_DASHBOARD_ACTIVITY,
  ROUTE_PAGE_DASHBOARD_MEMBERS,
  ROUTE_PAGE_DASHBOARD_SETTINGS,
]

// Which sidebar folder the current route highlights, or null when none does
export const useActiveFolder = (folderId: ID) => {
  const { pathname } = useLocation()
  const onSection = SECTION_ROUTES.some((route) => matchPath(route, pathname))

  return onSection ? null : folderId
}
